import { cn } from '../../../utils/string/cn.utils';

const ButtonSelect = ({
  active,
  label,
  classNames = { root: '', label: '' },
  onClick,
}) => {
  return (
    <div
      className={cn(
        'flex content-center items-center self-stretch h-[32px] py-[8px] px-[12px] gap-[10px] rounded-[4px] border-[1px] border-solid border-[#F1F2F2] bg-[#F1F2F2] hover:bg-[#EDFAFF] hover:border-[#006EE5] cursor-pointer transition-all duration-300',
        active && 'border-[1px] border-solid border-[#006EE5] bg-[#EDFAFF]',
        classNames.root
      )}
      onClick={onClick}
    >
      <span
        className={cn(
          'line-clamp-1 truncate text-label-medium grow',
          classNames.label
        )}
      >
        {label}
      </span>
    </div>
  );
};

export default ButtonSelect;
